'use strict';

import * as util from '../util/Common.js';
import {JsonLdUtil} from '../viewer/JsonLdManifestLoader.js';
import {IIIFv2Util} from '../viewer/IIIFv2Analyzer.js';

const privateMap = util.createPrivateMapper();

export class UniversalViewerAnalyzer {
  constructor(options){
    const pv = privateMap(this);
    pv.targetContexts = {
      'http://wellcomelibrary.org/ld/ixif/0/context.json': true,
      'http://files.universalviewer.io/ld/ixif/0/context.json': true
    };
    pv.sceneType
  }

  isTarget(json){
    const pv = privateMap(this);
    const contexts = JsonLdUtil.getLdField(json, '@context');
    return JsonLdUtil.checkContext(contexts, pv.targetContexts);
  }

  convertMediaSequence(seq){
    const scenes = [];
    const sequence = {
      viewTypes: ['default'],
      scenes: scenes
    };
    if (!seq.elements || !seq.elements.length) {
      return sequence;
    }
    const l = seq.elements.length;
    IIIFv2Util.extractAttributes(sequence, seq);

    for (let i = 0; i < l; i++) {
      const element = seq.elements[i];
      const source = {};
      const scene = {
        id: element['@id'],
        source: source
      };

      source['id'] = element['@id'];
      source['type'] = element['@type'];
      source['format'] = element['format'];
      source['thumbnail'] = IIIFv2Util.createThumbnail(element['thumbnail']);
      // view.createThumbnail = function(contEl, size, emptyFunc) {
      //   return createThumbnail(contEl, new Point2D(size), element, emptyFunc);
      // };
      IIIFv2Util.extractAttributes(scene, element);
      // extractIIIFAttributesV2(m, scene, element);
      scenes[i] = scene;
    }
    return sequence;
  };


  analyze(json, manifest){
    // const formatMap = options.formatMap ? options.formatMap : {};

    if (json.mediaSequences) {
      util.each(json.mediaSequences, (mediaSequence) => {
        if (!mediaSequence) {
          return;
        }
        const seq = this.convertMediaSequence(mediaSequence);
        manifest.sequences.push(seq);
      })
    }
    // if (json.thumbnail) {
    //   m.createThumbnail = function(contEl, size, emptyFunc) {
    //     return createThumbnail(contEl, new Point2D(size), json, emptyFunc);
    //   };
    // }
  }

  analyzeAnnotationList(json, res){
  }
}
